import { ChangeEvent, FC } from 'react';
// Components
import { Input, Select } from 'components/Controls';
// Models
import IRegistrationField from 'models/RegistrationField';
// Types
import RegistrationFieldTypes from 'types/RegistrationFieldTypes';

type Props = {
  field: IRegistrationField;
  value: string;
  error?: string;
  onChange: (event: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const RegistrationFieldInput:FC<Props> = ({ field, value, error, onChange }) => {
  if (field.type === RegistrationFieldTypes.SingleChoice) {
    return (
      <div>
        <Select
          id={field.ref} name={field.ref}
          options={[
            { value: '', label: field.title, disabled: field.required },
            ...(field.choices || []).map((choice) => ({ value: choice.ref, label: choice.title })),
          ]}
          value={value}
          onChange={onChange}
        />
        {error ? (
          <span className="block text-red-500 text-xs pl-4 -mt-2">{error}</span>
        ) : null}
      </div>
    );
  }

  return (
    <Input
      name={field.ref} id={field.ref} placeholder={field.title}
      className="bg-[#f2f2f2]"
      value={value}
      onChange={onChange}
      error={Boolean(error)}
      errorText={error || ''}
    />
  );
}

export default RegistrationFieldInput;
